// import React, { useRef, useEffect } from "react";
// import "./heading.scss";
// import { AiIcon, headingimg, imgwithHeading, InstaIcon, PsIcon } from "..";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);
// const Heading = () => {
//   const imgRef = useRef(null);

//   useEffect(() => {
//     if (imgRef.current) {
//       gsap.to(imgRef.current, {
//         rotationY: 180,
//         ease: "none",
//         scrollTrigger: {
//           trigger: imgRef.current,
//           start: "top top+=5",
//           end: "bottom top-=300",
//           scrub: true,
//         },
//       });
//     }
//   }, []);

//   return (
//     <div id="bannerSection">
//       <div className="container heading-section">
//         <div className="row align-items-end gy-4 heading-wrap">
//           <div className="col-12 col-md-auto heading-text-wrap">
//             <p className="heading-text">Design and branding agency</p>
//             {/* <img
//               src={PsIcon}
//               alt="Photoshop"
//               className="icon-absolute ps-icon bounce"
//             /> */}
//           </div>
//           <div className="col-12 col-md-auto">
//             {/* <img
//             src={headingimg}
//             alt="heading-Img"
//             className="heading-img"
//             ref={imgRef}
//             style={{ willChange: "transform", width: "100px" }}
//           /> */}
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-12 subheading">
//             <h1>
//               Brand.<span className="design">Design</span>.Product In-House
//               Development. & More
//               <br />
//               <img
//                 src={imgwithHeading}
//                 alt="Img-heading"
//                 className="inline-img"
//               />
//             </h1>

//             {/* Icons moved outside <h1> to appear on next line */}
//             {/* <div className="icon-wrap">
//               <img
//                 src={InstaIcon}
//                 alt="Figma"
//                 className="icon-absolute insta-icon-over bounce"
//               />
//               <img
//                 src={AiIcon}
//                 alt="Illustrator"
//                 className="icon-behind ai-icon-bg bounce"
//               />
//             </div> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Heading;

import React, { useEffect, useRef } from "react";
import "../headingComponent/heading.scss";
import { BGVideo2 } from "..";
import Aos from "aos";

const Heading = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    const startTime = 1;
    const endTime = 21;

    if (video) {
      video.currentTime = startTime;

      const checkTime = () => {
        if (video.currentTime >= endTime) {
          video.currentTime = startTime;
        }
      };

      video.addEventListener("timeupdate", checkTime);

      return () => {
        video.removeEventListener("timeupdate", checkTime);
      };
    }
  }, []);

  return (
    <div id="heading" className="creative-wrapper">
      <video
        className="bg-video"
        ref={videoRef}
        src={BGVideo2}
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="frosted-glass glassContainer">
        <div className="text-wrapper">
          <div
            className="text-line creative z-top"
            data-aos="zoom-in"
            data-aos-delay="0"
            data-aos-duration="4000"
            // data-aos="fade-down"
            // data-aos-easing="linear"
            // data-aos-duration="1500"
          >
            {/* <p className="since">Since 2025</p> */}
            <span>CREATIVE</span>
          </div>

          <div
            className="text-line design z-overlap"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="4000"
            // data-aos="flip-left"
            // data-aos-easing="ease-out-cubic"
            // data-aos-duration="2000"
          >
            <span>DESIGN</span>
          </div>

          {/* <img src={AiIcon} alt="Illustrator" className="icon-behind ai-icon-bg bounce" /> */}

          <div
            className="text-line agency z-bottom"
            data-aos="zoom-in"
            data-aos-delay="800"
            data-aos-duration="4000"
            // data-aos="fade-up"
            // data-aos-duration="3000"
          >
            <span>AGENCY</span>
          </div>

          {/* <img src={PsIcon} alt="Photoshop" className="icon-absolute ps-icon bounce" /> */}
          {/* <img src={InstaIcon} alt="Figma" className="icon-absolute insta-icon-over bounce" /> */}
        </div>
      </div>
    </div>
  );
};

export default Heading;

// import React, { useEffect, useRef } from "react";
// import "../headingComponent/dummy.scss";
// import { BGVideo2 } from "..";

// const Heading = () => {
//   const videoRef = useRef(null);

//   useEffect(() => {
//     const video = videoRef.current;
//     const startTime = 1;
//     const endTime = 21;

//     if (video) {
//       video.currentTime = startTime;

//       const checkTime = () => {
//         if (video.currentTime >= endTime) {
//           video.currentTime = startTime;
//         }
//       };

//       video.addEventListener("timeupdate", checkTime);

//       return () => {
//         video.removeEventListener("timeupdate", checkTime);
//       };
//     }
//   }, []);

//   return (
//     <div className="creative-wrapper">
//       <video
//         className="bg-video"
//         ref={videoRef}
//         src={BGVideo2}
//         autoPlay
//         loop
//         muted
//         playsInline
//       />
//       <div className="frosted-glass">
//         <div className="text-wrapper">
//           <div className="text-line creative z-top">
//             <svg className="animated-text creative-text">
//               <text x="50%" y="50%" dy=".35em" textAnchor="middle">
//                 CREATIVE
//               </text>
//             </svg>
//           </div>

//           <div className="text-line design z-overlap">
//             <svg className="animated-text design-text">
//               <text x="50%" y="50%" dy=".35em" textAnchor="middle">
//                 DESIGN
//               </text>
//             </svg>
//           </div>

//           <div className="text-line agency z-bottom">
//             <svg className="animated-text agency-text">
//               <text x="50%" y="50%" dy=".35em" textAnchor="middle">
//                 AGENCY
//               </text>
//             </svg>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Heading;
